import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { NamedContainer } from '@alfa-bank/site-named-container';

import type { TProgressBar } from './models';
import { ProgressInfo } from './progress-info';

export const ProgressBar: FC<TProgressBar> = ({
    Progress,
    ProgressV2,
    bottomTextMask,
    captionText = 'Далее оформление доставки',
    isMobile,
    maxStep,
    maxValue = 100,
    slogan,
    sloganPostfix = '',
    step,
    steps,
    styles,
    theme,
    topTextMask = 'Станьте на #percent# ближе к X5-Карте \u2014 заполните поле «#field#»',
    type = 'hatching',
    ...rest
}) => {
    if (type === 'stepper') {
        return (
            <ProgressV2
                caption
                captionText={captionText}
                header="steps"
                line={type}
                maxStep={maxStep}
                step={step}
                steps={steps}
                styler={{ marginBottom: isMobile ? 24 : 32 }}
            />
        );
    }

    return (
        <Progress
            {...rest}
            className={cn(styles.external, {
                [styles.green]: theme === 'green',
            })}
            maxValue={maxValue}
            slogan={slogan}
            sloganPostfix={sloganPostfix}
            styler={{ marginBottom: 24 }}
            theme={theme}
        >
            <NamedContainer name="topText">
                <ProgressInfo isSlogan={!!slogan} textMask={slogan ? slogan : topTextMask} />
            </NamedContainer>
        </Progress>
    );
};
